import { Stack, Typography, styled } from '@mui/material';
import { PageHeaderContainer } from 'src/components/PageHeader/PageHeaderContainer';
import { VerticalDivider } from 'src/components/VerticalDivider/VerticalDivider';
import { ChannelAvatar } from 'src/features/channel/ChannelAvatar';
import { Roles } from 'src/features/workspace/WorkspaceShareMemberRoleSelectProps';
import { WorkspaceShareMembersAvatar } from 'src/features/workspace/WorkspaceShareMembersAvatar';
import { HeaderIcon } from 'src/layouts/DashboardLayout/shared/styles';
import { useChatContext } from 'src/provider/ChatContext';
import {
  ChatDetailsTitle,
  useChatDetailsDialog,
} from 'src/sections/@dashboard/chat/shared/ChatOverviewDialog';
import { useChatAllowedAction } from 'src/sections/@dashboard/chat/shared/useChatAllowedAction';
import { PastSessions } from './PastSessions';
import { ScheduleCall } from './ScheduleCall';
import { ChatHeaderProps } from './types';

const StyledTitle = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textTransform: 'capitalize',
}));

export const ChatHeaderVoice = ({ conversation }: ChatHeaderProps) => {
  const { showChatDetailsDialog } = useChatDetailsDialog();
  const userPermissions = useChatAllowedAction({ conversation });

  const { isCompact } = useChatContext();

  const handleShowDetails = (tab?: ChatDetailsTitle) => {
    showChatDetailsDialog({ conversationId: conversation._id, tab });
  };

  return (
    <PageHeaderContainer>
      <Stack
        direction="row"
        alignItems="center"
        overflow="hidden"
        gap={1}
        onClick={() => handleShowDetails()}
        sx={{ cursor: 'pointer' }}
      >
        <HeaderIcon>
          <ChannelAvatar key={conversation._id} channel={conversation} />
        </HeaderIcon>
        <StyledTitle variant="h4">{conversation.name}</StyledTitle>
      </Stack>
      {conversation?._id && (
        <Stack direction="row" alignItems="center" gap={1.5}>
          {userPermissions.role === Roles.ADMIN && (
            <ScheduleCall
              onClick={() => handleShowDetails(ChatDetailsTitle.CALL_SCHEDULE)}
              compact={isCompact}
            />
          )}

          <PastSessions channelId={conversation._id} compact={isCompact} />

          <VerticalDivider height="32px" />

          <Stack
            onClick={() => handleShowDetails(ChatDetailsTitle.MEMBERS)}
            style={{ cursor: 'pointer' }}
          >
            <WorkspaceShareMembersAvatar
              members={conversation.participants}
              size="small"
              compact={isCompact}
            />
          </Stack>
        </Stack>
      )}
    </PageHeaderContainer>
  );
};
